/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Days_Fixed_QuestionInputs */

const en_us2_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are those always the same days?`)
};

const pt_br2_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses dias são sempre os mesmos?`)
};

const es_419_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son siempre los mismos días?`)
};

const pt_pt2_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses dias são sempre os mesmos?`)
};

const fr_fr2_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont toujours les mêmes jours ?`)
};

const de_de2_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind das immer dieselben Tage?`)
};

const it_it2_onboarding_days_fixed_question = /** @type {(inputs: Onboarding_Days_Fixed_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono sempre gli stessi giorni?`)
};

/**
* | output |
* | --- |
* | "Are those always the same days?" |
*
* @param {Onboarding_Days_Fixed_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_days_fixed_question = /** @type {((inputs?: Onboarding_Days_Fixed_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Days_Fixed_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_days_fixed_question(inputs)
	if (locale === "es-419") return es_419_onboarding_days_fixed_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_days_fixed_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_days_fixed_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_days_fixed_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_days_fixed_question(inputs)
	return en_us2_onboarding_days_fixed_question(inputs)
});
export { onboarding_days_fixed_question as "onboarding.days_fixed.question" }